import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import { FirebaseAppProvider } from "reactfire";
import App from "./App";
import { firebaseConfig } from "./firebase";
import reportWebVitals from "./reportWebVitals";

const root = ReactDOM.createRoot(
  document.getElementById("root") as HTMLElement
);
root.render(
  <React.StrictMode>
    <FirebaseAppProvider firebaseConfig={firebaseConfig} suspense={true}>
      <App />
    </FirebaseAppProvider>
  </React.StrictMode>
);

reportWebVitals();
